/* classAdd
========================================================= */
export function classAdd($) {
  /* class追加 */
  $('table.schedule-date td p:last-child').addClass('last');
  $('.widget ul li:last-child').addClass('last');
  $('#sitemap-list li:even').addClass('color');
  $('.topic-list dl:last-child, .staffblogbox-inner dl:last-child').addClass('last');
  $('.eye-catch > a, .thumbnail-box > a').addClass('js-lightbox');
}
